var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEprInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6794 5.7963C11.759 11.6545 1.73664 13.9977 0.623047 5.7963C0.623047 -0.0618441 10.5658 -2.48879 11.6794 5.7963Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6839 8.19787V6.56596C6.7006 6.33917 6.6625 6.11172 6.57259 5.90484C6.54317 5.82626 6.49789 5.75589 6.43822 5.69924C6.3786 5.64266 6.30766 5.60125 6.23052 5.57848C6.13668 5.52191 6.0269 5.5012 5.92029 5.51986C5.92029 5.51986 5.72942 5.51987 5.66582 5.72909V8.78368C5.61014 8.94269 5.78507 9.1101 5.95212 9.16032C6.11913 9.21053 6.06357 9.1603 6.11921 9.21888C6.25363 9.22415 6.3888 9.20434 6.51682 9.16032L6.57259 9.1101C6.64099 9.01611 6.67992 8.90202 6.6839 8.78368V8.19787Z",
    fill: "#193666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14897 3.84635C5.12751 3.5742 5.2064 3.30374 5.36787 3.09033C5.53012 2.87693 5.76303 2.73666 6.01995 2.69816C6.27687 2.65975 6.5385 2.72594 6.75085 2.88335C6.96242 3.04077 7.10972 3.27744 7.16142 3.54508C7.18293 3.81723 7.10421 4.08769 6.94274 4.30109C6.78049 4.5145 6.54736 4.65477 6.29044 4.69326C6.03353 4.73176 5.77182 4.66549 5.5602 4.50807C5.34785 4.35065 5.20068 4.11399 5.14897 3.84635Z",
    fill: "#193666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEprInfoIcon);
export default __webpack_public_path__ + "static/media/epr_info_icon.a4b64a3eda736235a723d4c38db94ee7.svg";
export { ForwardRef as ReactComponent };